export const response = ({ response }) => response;
export const getUser = ({ user }) => user;
export const getProfileSelected = ({ profileSelected }) => profileSelected;
export const getLayoutTitle = ({ title }) => title;
export const getBreadcrumbs = ({ breadcrumbs }) => breadcrumbs;
export const getLayoutHomeDoubt = ({ layoutHomeDoubt }) => layoutHomeDoubt;
export const getItemsRandomizedStor = ({ itemsRandomizedStor }) => itemsRandomizedStor;
export const getItemsOrganizedStor = ({ itemsOrganizedStor }) => itemsOrganizedStor;
export const getRegisterTab = ({ registerTab }) => registerTab;
export const getApiDetailsTab = ({ apiDetailsTab }) => apiDetailsTab;
export const getToken = ({ auth }) => auth && auth.access_token ? auth.access_token : null;
export const getRefrechToken = ({ auth }) => auth && auth.refresh_token ? auth.refresh_token : null;
export const getDataUser = ({ dadosUsuario }) => dadosUsuario;
export const getAuth = ({ auth }) => auth ? auth : null;
export const getIdUser = ({ dadosUsuario }) => dadosUsuario && dadosUsuario.sub ? dadosUsuario.sub : null;
export const getRolesUser = ({ dadosUsuario }) => dadosUsuario && dadosUsuario.resource_access && dadosUsuario.resource_access['marketplace-frontend'] && dadosUsuario.resource_access['marketplace-frontend'].roles ? dadosUsuario.resource_access['marketplace-frontend'].roles : [];
export const getNameUser = ({ dadosUsuario }) => dadosUsuario && dadosUsuario.name ? dadosUsuario.name : '';
export const getEmailUser = ({ dadosUsuario }) => dadosUsuario && dadosUsuario.email ? dadosUsuario.email : '';
export const getExpiredToken = ({ dadosUsuario }) => dadosUsuario && dadosUsuario.exp ? dadosUsuario.exp : '';
export const getProfilesUser = ({ dadosUsuario }) => {
    let perfil = [];
    let roles = dadosUsuario && dadosUsuario.realm_access && dadosUsuario.realm_access.roles ? dadosUsuario.realm_access.roles : [];
    if (roles.length > 0) {
        for (let index = 0; index < roles.length; index++) {
            const element = roles[index];
            if (element.includes('profile_')) {
                perfil.push(element)
            }

        }

    }

    return perfil;

}
export const getProfilesUserType = ({ dadosUsuario }) => (type) => {
    let roles = dadosUsuario && dadosUsuario.realm_access && dadosUsuario.realm_access.roles ? dadosUsuario.realm_access.roles : [];
    if (roles.length > 0) {
        return roles.find((role) => {
            return role.includes(`profile_${type}`);
        });
    }
};

export const getOnFullscreen = ({ onFullscreen }) => onFullscreen;

export const getRolesUserRoute = ({ dadosUsuario }) => (route) => {
    let roles = dadosUsuario && dadosUsuario.resource_access && dadosUsuario.resource_access.marketplace && dadosUsuario.resource_access.marketplace.roles ? dadosUsuario.resource_access.marketplace.roles : [];
    if (roles.length > 0) {
        return roles.find((role) => {
            return role.includes(route);
        });
    }
}

export const getSelectedItemMenu = ({ selectedItemMenu }) => selectedItemMenu;
export const getSrcImgemApiDefault = ({ srcImgemApiDefault }) => srcImgemApiDefault;

export const getTermsPoliciesTypes = ({ termsPoliciesTypes }) => termsPoliciesTypes;
export const getTermsPoliciesData = ({ termsPoliciesData }) => termsPoliciesData;
export const getTermsPoliciesAccepetd = ({ termsPoliciesAccepetd }) => termsPoliciesAccepetd;
export const getNoUseCookies = ({ noUseCookies }) => noUseCookies;
export const getIdUserWhoAccepted = ({ idUserWhoAccepted }) => idUserWhoAccepted;
export const getkeysSessions = () => ['scope', 'access_token', 'refresh_token', 'token_type', 'refresh_expires_in', 'not-before-policy', 'session_state', 'expires_in']
export const getCountApproval = ({ countApproval }) => countApproval;
export const getMenuGroupsActive = ({ menuGroupsActive }) => menuGroupsActive;

export const getHeaderAdminType = ({ headerAdminType }) => headerAdminType;



